import ModelProxy, {required, optional} from './proxy';


export class DrugRegimen extends ModelProxy {

  static propTypes = {
    uuid: required,
    drugName: required,
    dose: optional,
    freq: optional
  };

}


export default class RxHistory extends ModelProxy {

  static propTypes = {
    uuid: required,
    patientUuid: required,
    startDate: required,
    stopDate: required,
    dateMatch: required,
    weeks: required,
    durationUnknown: required,
    orderUnknown: required,
    regimenName: required,
    drugs: required
  };

  static setDrugs(self, value) {
    self.props.drugs = value.map(v => (
      v instanceof DrugRegimen ?
        v : new DrugRegimen(v)
    ));
  }

}



// WEBPACK FOOTER //
// ./src/models/rx-history.js